const ICONS = {
  success: '<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 17l7 7L26 9"/></svg>',
  error: '<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="2"><circle cx="16" cy="16" r="12"/><path d="M16 10v8"/><circle cx="16" cy="22" r="1" fill="currentColor" stroke="none"/></svg>',
  warning: '<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="2"><path d="M16 3L2 29h28L16 3z"/><path d="M16 13v8"/><circle cx="16" cy="25" r="1" fill="currentColor" stroke="none"/></svg>',
  info: '<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="2"><circle cx="16" cy="16" r="12"/><path d="M16 15v8"/><circle cx="16" cy="10" r="1" fill="currentColor" stroke="none"/></svg>',
  loading: '<svg class="toast__spinner" viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="3"><circle cx="16" cy="16" r="12" stroke-opacity="0.25"/><path d="M28 16a12 12 0 0 0-12-12" stroke-linecap="round"/></svg>'
};

const CLOSE_ICON = '<svg width="16" height="16" viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="2"><path d="M7 7l18 18M25 7L7 25"/></svg>';

const AUTODISMISS_MS = 5000;
const isAutoDismissable = (type) => type !== 'error' && type !== 'warning' && type !== 'loading';

export function showToast(message, { type = 'success' } = {}) {
  let container = document.getElementById('toast-container');
  if (!container) {
    container = document.createElement('div');
    container.className = 'toast-container';
    container.id = 'toast-container';
    document.body.appendChild(container);
  }

  const toast = document.createElement('div');
  let currentType = type;
  toast.className = `toast toast--${currentType}`;
  toast.setAttribute('role', currentType === 'error' ? 'alert' : 'status');
  toast.innerHTML =
    `<div class="toast__icon">${ICONS[currentType] || ICONS.success}</div>` +
    '<div class="toast__content"><p class="toast__message"></p></div>';
  toast.querySelector('.toast__message').textContent = message;

  const exit = () => {
    if (!toast.parentNode || toast.classList.contains('toast--exit')) return;
    toast.classList.add('toast--exit');
    let removed = false;
    const cleanup = () => { if (removed) return; removed = true; toast.remove(); };
    toast.addEventListener('animationend', cleanup, { once: true });
    setTimeout(cleanup, 1000);
  };

  const addCloseButton = () => {
    if (toast.querySelector('.toast__close')) return;
    const btn = document.createElement('button');
    btn.className = 'toast__close';
    btn.setAttribute('aria-label', 'Dismiss');
    btn.innerHTML = CLOSE_ICON;
    btn.addEventListener('click', exit);
    toast.appendChild(btn);
  };

  addCloseButton();

  container.appendChild(toast);

  let dismissTimer = isAutoDismissable(currentType) ? setTimeout(exit, AUTODISMISS_MS) : null;

  return {
    update(newMessage, { type: newType } = {}) {
      if (dismissTimer) { clearTimeout(dismissTimer); dismissTimer = null; }
      if (newType && newType !== currentType) {
        toast.classList.remove(`toast--${currentType}`);
        toast.classList.add(`toast--${newType}`);
        toast.querySelector('.toast__icon').innerHTML = ICONS[newType] || ICONS.success;
        toast.setAttribute('role', newType === 'error' ? 'alert' : 'status');
        currentType = newType;
      }
      toast.querySelector('.toast__message').textContent = newMessage;
      if (isAutoDismissable(currentType)) dismissTimer = setTimeout(exit, AUTODISMISS_MS);
    },
    dismiss: exit
  };
}
